import { cleanStringForURL } from "app/main/urlFormatter";
import { clientConfig } from "app/config";

export const analysisDetailUrl = (isin: string, analysisId: string, title: string) => {
    const cleanTitle = cleanStringForURL(title);
    return `${clientConfig.urlPathPrefixNews}boerse-analysen/${isin.toLowerCase()}/${cleanTitle}/${analysisId}`;
};
